export const ALLOWED_USER_IDS = [
  "ae7d874b-9cff-4efa-a9b7-55b30aa74e05",
  "e0f17889-7fb9-4a70-8484-3aab2453f3ba",
  "e5e958b1-0da0-49c8-a351-fe0398b8fc4b",
  "ee53bbef-7d1f-4e4e-9bd2-72bc21958f88",
  "3188bcb2-1be0-4214-b8e9-4f4573b66644",
  "cd6f1363-105d-4bec-af64-e497526941f7",
  "bb8e5566-9cb1-42ec-a78a-95521d500083",
  "eb4abbfe-8bc3-4592-bd49-189cfd9d6c12",
  "396b57fb-973d-4d62-98a0-42b498caca0a",
  "f0aefd60-13f2-4e91-bfa4-344c85acc669",
  "0041f44a-a173-4ff9-9cee-060292b53de4",
  "691c464f-8637-4a46-a3d7-cab0de738afe",
  "9430d9e4-5f02-48a0-b83f-cc90df7a4a2f",
  "8dfc31e7-726b-4af9-af97-ac0cfbf04c02",
  "917dc918-b123-4c21-bfdf-24f2f7b0861b",
  "3223ae68-6dfe-4b31-b075-34a2c97f08b7",
  "02716a42-fe27-4724-8cce-cac66495a18d",
  "7ccc842d-c770-4664-961d-fd24de1e92f9",
  "0ccec983-fc14-47cb-b722-98770b1e4e17",
  "8e518925-f1f3-4c22-9edd-b0780b0283fc",
  "e56936b0-1716-4cdf-a7fe-d507f9ce7077",
  "bd10485a-5974-4190-b02f-a1d9bdf98738",
  "1f0b4d27-52b6-4269-9ccf-6aeaf8a7b467",
];

export const demoUserIds=[
  // "dfad1009-6f04-43d0-95e7-419affb9016a",   //test2@gmail.com  local
  "780620b8-2f15-48ac-b574-8284a0f6302b",    //prod vedant
]
